import React from 'react'

const Quote = ({ fill = '#FFFFFF', width = '16', height = '11' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.53333 10.6133C8.32 9.27658 8.21333 8.07357 8.21333 7.00422C8.21333 4.58037 8.77333 2.80703 9.89333 1.68422C11.0489 0.561407 12.8089 0 15.1733 0V2.9407L15.2 2.96744C14.7911 2.96744 14.4533 2.99417 14.1867 3.04764C13.8844 3.10111 13.6444 3.19022 13.4667 3.31498C13.3067 3.43973 13.1644 3.5734 13.04 3.71598C12.9333 3.84074 12.8533 4.03678 12.8 4.30412C12.7467 4.57146 12.72 4.80315 12.72 4.9992C12.7022 5.12395 12.6933 5.4002 12.6933 5.82794H15.1733V10.6133H8.53333ZM0.32 10.64C0.106667 9.30332 0 8.1003 0 7.03095C0 4.6071 0.568889 2.83377 1.70667 1.71096C2.82667 0.588141 4.58667 0.0267328 6.98667 0.0267328V2.99417C6.59556 2.99417 6.25778 3.0209 5.97333 3.07437C5.65333 3.12784 5.42222 3.21695 5.28 3.34171C5.06667 3.50211 4.92445 3.63578 4.85333 3.74271C4.74667 3.86747 4.66667 4.06352 4.61333 4.33085L4.50667 5.02593V5.85467H6.96V10.64H0.32Z"
        fill={fill}
      />
    </svg>
  )
}

export default Quote
